import { CommonModule } from '@angular/common';
import { Component, Signal, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';
import { switchMap } from 'rxjs';
import { ObjectType } from '../../../tokens-and-interfaces';
import { AssociatedCrmObjectService } from './associated-crm-object.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

interface AssociationIdentifier {
  objectType: ObjectType;
  namespace: string;
  objectId: string;
}

@Component({
  styleUrls: ['../shared.scss'],
  templateUrl: './associated-crm-object.component.html',
  providers: [AssociatedCrmObjectService],
  imports: [RouterLink, CommonModule, BlankValueComponent],
})
export class AssociatedCrmObjectComponent extends CustomCellComponent {
  private associationIdentifier = signal<AssociationIdentifier | undefined>(undefined);

  set value(identifiers: AssociationIdentifier) {
    this.associationIdentifier.set(identifiers);
  }

  protected displayName: Signal<string | undefined>;
  protected redirectUrl: Signal<string | undefined>;
  protected isLoaded: Signal<boolean> = computed(() => this.displayName() !== undefined);

  constructor(private service: AssociatedCrmObjectService) {
    super();

    const key = toObservable(this.associationIdentifier);
    this.displayName = toSignal(
      key.pipe(switchMap((key) => this.service.getCrmObjectName(key?.namespace, key?.objectType, key?.objectId))),
    );
    this.redirectUrl = toSignal(
      key.pipe(switchMap((key) => this.service.getCrmObjectUrl(key?.namespace, key?.objectType, key?.objectId))),
    );
  }
}
